import { Component, OnInit } from '@angular/core';
import { SchedulerSettingsService } from '../../services/scheduler-settings.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';

@Component({
    standalone: false,
    selector: 'app-application-settings',
    templateUrl: './application-settings.component.html',
    styleUrls: ['./application-settings.component.scss']
})
export class ApplicationSettingsComponent implements OnInit {
    private destroyed$ = new Subject<void>();
    settings: ISchedulerSettings;
    showSpinner: boolean = true;

    constructor(protected readonly schedulerSettingsService: SchedulerSettingsService) {}

    ngOnInit(): void {
        this.schedulerSettingsService
            .requestSchedulerSettings()
            .pipe(
                takeUntil(this.destroyed$),
                filter(value => !!value)
            )
            .subscribe(scheduleSettings => {
                this.settings = scheduleSettings.clone();
                this.showSpinner = false;
            });
    }

    ngOnDestroy(): void {
        this.destroyed$.next(undefined);
        this.destroyed$.complete();
    }
}
